import _ from 'lodash'

function updateLineDataSource (lineFeature, data, serieSourceIds) {
	lineFeature.set(_.extend({}, data, {
		serieSourceId: serieSourceIds.id,
		serieSourceTempId: serieSourceIds.tempId
	}))
}

export default updateLineDataSource

updateLineDataSource.__filename__ = 'charts/edit/analytics/update-line-data-source.js'
